// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#eb5757","bgColor":"white","header":"c_g","experience":"c_h","period":"c_j","company":"c_k","content":"c_l"};